import type { ConversationMessage, ToolMessage } from './types';
import { isAssistantMessage, isToolMessage } from './types';

/**
 * Drops tool results that no longer answer a preceding assistant tool call.
 *
 * The API rejects the entire request when it sees one, so a single orphan costs the user their
 * whole turn. They appear whenever an assistant message is dropped while its results survive:
 * filtered out of the history as display-only, superseded as a context message, or never
 * assigned its tool_calls because the stream was interrupted. A shape rule rather than a size
 * one, so Conversation.getMessagesForAPI applies it to every request regardless of length.
 */
export function dropOrphanedToolMessages(messages: ConversationMessage[]): ConversationMessage[] {
    const knownToolCallIds = new Set<string>();
    for (const msg of messages) {
        if (isAssistantMessage(msg) && msg.tool_calls) {
            for (const toolCall of msg.tool_calls) {
                knownToolCallIds.add(toolCall.id);
            }
        }
    }
    return messages.filter(
        (msg) => !isToolMessage(msg) || knownToolCallIds.has((msg as ToolMessage).tool_call_id),
    );
}
